import { apiRequest } from ".";
import {
  ExNyRoute,
  PrRoute,
  ExRoute,
  AcRoute,
  MiRoute,
  CoRoute,
} from "../utils/allRouteId";

const config = {
  "Content-Type": "application/json",
};

export const getAllApplicants = async () => {
  const [url, id, method] = ["api/Applicant/GetApplicantSignup/Id/", "", "GET"];
  let result = await apiRequest(url, method);
  return result;
};

export const getWorkExperience = async (applicantId: string) => {
  const [url, method] = [
    `api/Applicant/GetJobHistoryById?applicantId=${applicantId}`,
    "GET",
  ];
  let result = await apiRequest(url, method, {}, config);
  return result;
};

export const getAllQualification = async (applicantId: string) => {
  const [url, method] = [
    `api/Applicant/GetAcademicByApplicantId?applicantId=${applicantId}`,
    "GET",
  ];
  let result = await apiRequest(url, method, {}, config);
  return result;
};


export const getQualifications = async (applicantId: string) => {
  const ssce = new Promise((resolve, reject) => {
    let url = `api/Applicant/GetAcademicByApplicantId?applicantId=${applicantId}&qualificationId=10`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  //  const referee = new Promise((resolve, reject) => {
  //   let url = `api/Applicant/getreferencebyapplicantid?applicantId=${applicantId}`;
  //   const method = "GET";
  //   apiRequest(url, method, {}, config)
  //     .then((data) => resolve(data))
  //     .catch((err) => reject(err));
  // });

  const ond = new Promise((resolve, reject) => {
    let url = `api/Applicant/GetAcademicByApplicantId?applicantId=${applicantId}&qualificationId=2`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  const bsc = new Promise((resolve, reject) => {
    let url = `api/Applicant/GetAcademicByApplicantId?applicantId=${applicantId}&qualificationId=3`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  const msc = new Promise((resolve, reject) => {
    let url = `api/Applicant/GetAcademicByApplicantId?applicantId=${applicantId}&qualificationId=19`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  return Promise.allSettled([ssce, ond, bsc, msc]).then((values) => values);
};

export const getSingleData = async (
  url: string,
  method: string = "GET",
  config: any = {},
  body: any = {}
) => {
  let result = await apiRequest(url, method, body, config);
  return result;
};

export const getSubmittedApplicants = async () => {
  const exam = new Promise((resolve, reject) => {
    let url = `api/Approval/GetAllSubmittedApplicantByRoute?RouteId=${ExNyRoute}`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  const prac = new Promise((resolve, reject) => {
    let url = `api/Approval/GetAllSubmittedApplicantByRoute?RouteId=${PrRoute}`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  const exec = new Promise((resolve, reject) => {
    let url = `api/Approval/GetAllSubmittedApplicantByRoute?RouteId=${ExRoute}`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  const acad = new Promise((resolve, reject) => {
    let url = `api/Approval/GetAllSubmittedApplicantByRoute?RouteId=${AcRoute}`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });

  const mili = new Promise((resolve, reject) => {
    let url = `api/Approval/GetAllSubmittedApplicantByRoute?RouteId=${MiRoute}`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
  
//   const getRefereesByApplicantId = async (applicantId: string) =>{
//   try {
//     const url = `/api/Applicant/getreferencebyapplicantid?applicantId=${applicantId}`;
//     const method = "GET";
//     const data = await apiRequest(url, method, {}, config);
//     return data;
//   } catch (error) {
//     console.error("Failed to fetch referees:", error);
//     throw error; // rethrow if you want the caller to handle it
//   }
// };


  const corp = new Promise((resolve, reject) => {
    let url = `api/Approval/GetAllSubmittedApplicantByRoute?RouteId=${CoRoute}`;
    const method = "GET";
    apiRequest(url, method, {}, config)
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
  return Promise.allSettled([exam, prac, exec, acad, mili, corp]).then(
    (values) => values
  );
};
